import { render, staticRenderFns } from "./ProcHandler.vue?vue&type=template&id=1800a1ef&"
import script from "./ProcHandler.vue?vue&type=script&lang=js&"
export * from "./ProcHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports